import { AnalyticService } from '@application/analytic/analytic.service';
import { withTranslation } from '@application/i18n/with_translation';
import { useTitle } from '@application/use_title';
import { Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { TopBar } from '@component/top_bar.component';
import { MyAccount } from '@feature/my_account/my_account.component';
import { useResolve } from '@visiba/instantiation';
import { useEffect } from 'react';

export function ScreenAccount() {
	const analyticService = useResolve(AnalyticService);
	useTitle(withTranslation('PW.Feature.MyAccount.Title'));

	useEffect(
		function analyticQuirk_whenComponentMounts() {
			analyticService.trackPageView({ customTitle: 'My account' });
		},
		[analyticService],
	);

	return (
		<>
			<TopBar.Content goBack title={withTranslation('PW.Feature.MyAccount.Title')} />

			<MyAccount.Root>
				<Flex gap={tokens.spacing.x2}>
					<MyAccount.Title />
					<MyAccount.Form />
				</Flex>
			</MyAccount.Root>
		</>
	);
}
